<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="py-2">
        <div class="max-w-7xl mx-auto sm:px-4 lg:px-6">
            <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">             
                <DxTabPanel>
                    <DxItem  icon="fields" title="List View" >
                        <ListViewLayout :modulekey="modulekey" :route_slug="slug" :studio="studio"/>
                    </DxItem>
                    <DxItem  icon="fields" title="Edit View" >
                        <EditViewLayout :modulekey="modulekey" :route_slug="slug" :studio="studio"/>
                    </DxItem>
                    <DxItem  icon="fields" title="Detail View" >
                        <DetailViewLayout :modulekey="modulekey"  :route_slug="slug" :studio="studio"/>
                    </DxItem>
                    <DxItem  icon="fields" title="Quick Create" >
                         <quick-create-layout :modulekey="modulekey" :route_slug="slug" :studio="studio" />
                    </DxItem>
                    <DxItem  icon="fields" title="Line Item" >
                         <line-item-view-layout :modulekey="modulekey" :route_slug="slug" :studio="studio" />
                    </DxItem>
                    <DxItem  icon="fields" title="Invoice Item" >
                         <invoice-item-view-layout :modulekey="modulekey" :route_slug="slug" :studio="studio" />
                    </DxItem>
                    <DxItem  icon="fields" title="Pivot View" >
                         <pivot-view-layout :modulekey="modulekey" :route_slug="slug" :studio="studio" />
                    </DxItem>
                </DxTabPanel>
            </div>
        </div>
    </div>
  </app-layout>
</template>

<style>
.card-style {
  height: 70px;
}

.icon-center{
     text-align: center;
      width: 100%;
}

</style>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DetailViewLayout from "./SubComponents/DetailViewLayout.vue";
import EditViewLayout from "./SubComponents/EditViewLayout.vue";
import ListViewLayout from "./SubComponents/ListViewLayout.vue";
import LineItemViewLayout from "./SubComponents/LineItemViewLayout.vue";
import InvoiceItemViewLayout from "./SubComponents/InvoiceItemViewLayout.vue";
import PivotViewLayout from "./SubComponents/PivotViewLayout.vue";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import QuickCreateLayout from './SubComponents/QuickCreateLayout.vue';

let collapsed = false;

export default {
  props: {
    modules: Array,
    modulekey: String,
    studio: Boolean,
    slug:String,
  },
  components: {
    AppLayout,
    PageTitle,
    DxTabPanel,
    DxItem,
    ListViewLayout,
    DetailViewLayout,
    EditViewLayout,
    LineItemViewLayout,
    QuickCreateLayout,
    InvoiceItemViewLayout,
    PivotViewLayout
  },

  data() {
    return {
      title: "Module Builder",
    };
  },
  methods: {
    sayHelloWorld() {
      alert("Hello world!");
    },
  },
  mounted() {
    //console.log("MODULE LAYOUT SLUG",this.slug);
  },
};
</script>
